import { ButtonWithLoadingIcon } from "../../general_components/content_management/reusableItems/buttons";
import { ConfirmationDialogue } from "../../general_components/forms/ConfirmationDialogue";
import { priceOnFinish } from "../../supplementary_components/priceInputDelegate";
import { API_ROOT, sendRequest } from "../../supplementary_components/requests";
import { addNotification, addPopup } from "../../supplementary_components/store";
import { ExpendedTenderDetails, getDefaultTimezone, isoToString } from "./expandedTenderDetails";
import styles from "./tender.module.scss";
import { Link } from 'react-router-dom';
// const currentDriversGenerator = (data) => {
//     let result = NestedValueExtractor(data, [["driver1", "firstName"], " / ", ["driver2", "firstName"] ])
//     if (result.slice(result.length-3, result.length) === '/ -'){
//         result = result.slice(0, result.length-3) + NestedValueExtractor(data, [["driver1", "lastName"]])
//     }
//     return result;
// }

export const TENDER_LISTING_CONF = {
    getRequestLink: API_ROOT+"loads/tenders",
    columnProportions: "0.7fr 1.5fr 0.6fr 0.9fr 0.9fr 0.9fr 0.5fr",
    dataTitle: "Tender",
    dataTitlePlural:"Tenders",
    category: 'tenders',
    categorizedList: {
        defaultOption: null,
        options:[{label: "Pending"}, {label: "Accepted"}, {label: "Cancelled"}, {label: "Rejected"}],
        refreshButton: true,
    },
    hasSidePadding: true,
    clickableRow:{
        expandingComponent: ExpendedTenderDetails
    },
    
    columns: [
        {
            label: "Shipment Number",
            columnName: "shipmentId",
            sortable: true,
            customComponent: (data, selectedCategory) => {
                // console.log(data);
                return <div key={"shipment-id-"+data.id} className={styles.customContainer}>{data.loadId ? <Link className={styles.linkToLoad} to={`/loads/${data.loadId}`}>{data.shipmentId}</Link> : data.shipmentId}</div> 
                
                // data.loadId ? <Link to={`/loads/${data.loadId}`}><div key={"shipment-id-"+data.id} className={styles.linkToLoad}>{data.shipmentId}</div></Link> : ;
                // switch (selectedCategory) {
                //     case "Rejected":
                //         return <div key={"shipment-id-"+data.id} className={styles.customContainer}>{getRejectedBy(data)}</div>
                //     case "Pending":
                //         const respondBy = data?.data?.respond_by ?? null;
                //         return <div key={"shipment-id-"+data.id} className={styles.customContainer}>{`${respondBy ? isoToString(respondBy, getDefaultTimezone()) : "-"}`}</div>
                //     default:
                //         const lastUpdated = data?.lastUpdate ?? null;
                //         return <div key={"shipment-id-"+data.id} className={styles.customContainer}>{lastUpdated ? isoToString(lastUpdated, getDefaultTimezone()) : "-"}</div>
                // }
                // if(selectedCategory === "Rejected"){
                //     return <div key={data.id} className={styles.rejectedByContainer}>{data.rejectedBy}</div>
                // }
                // return null;
            },
            // conditionalFormatting: (value) => {
            //     return `& > * {font-weight:bold; color:var(--gray);}`
            // },
        },
        {
            label: "Brokerage",
            columnName: "brokerName",
            sortable: true,
            // valueInterpreter: (value) => {                
            //     return value ? value["companyName"]:"THIRD PARTY TRAILER";
            // },
            // conditionalFormatting: (value) => {
            //     return `& > * {font-weight:bold; color:var(--gray);}`
            // },
        },
        {
            label: "Rate",
            columnName: "data",
            sortable: true,
            valueGenerator: (data) => {
                const charges = data?.data?.charges ?? null;
                if (Array.isArray(charges) && charges.length > 0) {
                    const total = charges.reduce((sum, charge) => {
                        const amount = charge?.amount;
                        const num = typeof amount === "string" ? parseFloat(amount) : Number(amount);
                        return sum + (Number.isFinite(num) ? num : 0);
                    }, 0);
                    return priceOnFinish(String(total)); // e.g. "$1,234.56"
                }
                return "-";
            },
            // conditionalFormatting: (value) => {
            //     return `& > * {font-weight:bold; color:var(--gray);}`
            // },
        },
        {
            label: "From",
            columnName: "data",
            valueGenerator: (data) => {
                try {
                    const address = data?.data?.stops[0]?.location?.address ?? null;
                    if(address){
                        return address.city + ", " + address.state;
                    }
                } catch (error) {
                }
                return "-";
            },
            // conditionalFormatting: (value) => {
            //     return `& > * {font-weight:bold; color:var(--gray);}`
            // },
        },
        {
            label: "To",
            columnName: "data",
            valueGenerator: (data) => {
                try {
                    const stops = data?.data?.stops ?? null;
                    if(stops && Array.isArray(stops) && stops.length > 0){
                        const stop = stops[stops.length - 1];
                        const address = stop?.location?.address ?? null;
                        if(address){
                            return address.city + ", " + address.state;
                        }
                    }
                } catch (error) {
                }
                return "-";
            },
            // conditionalFormatting: (value) => {
            //     return `& > * {font-weight:bold; color:var(--gray);}`
            // },
        },
        {
            label: (category)=>{
                return category === "Pending" ? "Respond By" : category === "Rejected" ? "Rejected By" : "Last Updated"
            },
            columnName: "data",
            customComponent: (data, selectedCategory) => {
                switch (selectedCategory) {
                    case "Rejected":
                        return <div key={"rejectedBy-"+data.id} className={styles.customContainer}>{getRejectedBy(data)}</div>
                    case "Pending":
                        const respondBy = data?.data?.respond_by ?? null;
                        return <div key={"respondBy-"+data.id} className={styles.customContainer}>{`${respondBy ? isoToString(respondBy, getDefaultTimezone()) : "-"}`}</div>
                    default:
                        const lastUpdated = data?.lastUpdate ?? null;
                        return <div key={"lastUpdated-"+data.id} className={styles.customContainer}>{lastUpdated ? isoToString(lastUpdated, getDefaultTimezone()) : "-"}</div>
                }
                // if(selectedCategory === "Rejected"){
                //     return <div key={data.id} className={styles.rejectedByContainer}>{data.rejectedBy}</div>
                // }
                // return null;
            },
            // valueGenerator: (data) => {
                
            //     return ;
            // },
            // conditionalFormatting: (value) => {
            //     return `& > * {font-weight:bold; color:var(--gray);}`
            // },
        },
        {
            label: (category)=>{
                return category === "Pending" ? "Actions" : "Status"
            },
            customComponent: (data, selectedCategory, RequestReload) => {
                if(selectedCategory === "Pending"){
                    return <div key={data.id + "A"} className={styles.actionsContainer}>
                        <ButtonWithLoadingIcon label="Accept" className={styles.acceptButton} action={(postAction)=>{
                            sendRequest("POST", API_ROOT+"loads/tenders/"+data.id+"/accept", null, (response)=>{
                                RequestReload();
                            }, (error)=>{
                                addNotification({message:error.customError ? error.customError : "Something went wrong", type:'alert'});
                                postAction();
                            });
                        }}/>
                        <ButtonWithLoadingIcon label="Reject" className={styles.rejectButton} action={(postAction)=>{
                            addPopup({
                                content:ConfirmationDialogue,
                                popupData: {
                                    action:(postResultAction)=>{
                                        sendRequest("POST", API_ROOT+"loads/tenders/"+data.id+"/reject", null, (response)=>{
                                            postAction();
                                            postResultAction(true);
                                            RequestReload();
                                        }, (error)=>{
                                            postAction()
                                            postResultAction(true);
                                            addNotification({message:error.customError ? error.customError : "Something went wrong", type:'alert'});
                                            
                                        });
                                    },
                                    name:"Confirm",
                                    formTitle:"Reject Tender",
                                    submitTitle:"Reject",
                                    method:"POST",
                                    message:"Are you sure you want to reject this tender?",
                                    cancelAction:(closePopup)=>{
                                        postAction();
                                        closePopup();
                                    }
                                },
                                postSuccessAction: (closePopup)=>{
                                    postAction();
                                    closePopup();
                                },
                                EZCloseAllowed:false
                            })
                        } } customSpinnerColor="var(--alert-color)"/>
                    </div>
                }else{
                    // if(data.status === "Accepted"){
                    //     if(data.invoiced){
                    //         return <div key={data.id + "I"} className={`${styles.statusContainer} ${styles[data.status]}`}>INVOICED</div>
                    //     }else if(data.completed){
                    //         return <div key={data.id + "C"} className={styles.actionsContainer}>
                    //         <ButtonWithLoadingIcon label="Invoice" className={styles.acceptButton} action={(postAction)=>{
                    //             sendRequest("POST", API_ROOT+"loads/tenders/"+data.id+"/invoice", null, (response)=>{
                    //                 RequestReload();
                    //             }, (error)=>{
                    //                 addNotification({message:error.customError ? error.customError : "Something went wrong", type:'alert'});
                    //                 postAction();
                    //             });
                    //         }}/></div>
                    //     }
                    // }
                    return <div key={data.id + "S"} className={`${styles.statusContainer} ${styles[data.status]}`}>{data.status}</div>
                }
            },
            alignment: "right",
        }
    ]
}

function getRejectedBy(data){

    const employee = data?.decisionMadeBy ?? null;
    if(employee){
        return employee.firstName + " " + employee.lastName;
    }
    return "-";
}